import CRUDTableComponent from '../../components/CRUDTableComponent'

const DiseasesTable = () => {
  const tableColumns = [
    {
      title: 'ID',
      dataIndex: 'id',
    },
    {
      title: 'Nombre',
      dataIndex: 'name',
      type: 'string',
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
  ]

  return (
    <CRUDTableComponent
      entityName={{ singular: 'Enfermedad', plural: 'Enfermedades' }}
      tableColumns={tableColumns}
      entityUrl="/diseases?sortBy=name"
    />
  )
}

export default DiseasesTable
